import React from 'react'
import cn from 'classnames'

import './styles.scss'
const bc = 'work-day-button'

export const DayButton = ({ checked, ...rest }) => (
  <button
    type="button"
    className={cn(bc, {
      [`${bc}--checked`]: checked,
    })}
    {...rest}
  />
)
